/**
 * USERS REQUESTS
 */

import axios from 'axios';
import { USER_REQUESTS } from '../apiUrl'
import Axios from './axiosSetup';

// import Axios from './axiosSetup';

/**
 * Registration
 * @param {*} formData 
 * @returns 
 */
export function SharedRequest(formData: object) {
  const baseURL = process.env.REACT_APP_API_URL;
  let req = axios.create({
    baseURL,
    responseType: 'json',
    timeout: 15000, // return timeout error ater 8 seconds
    withCredentials: false,
    headers: {
        'Content-Type': 'multipart/form-data'
    }
  })
  req.defaults.headers.common.Authorization = `Bearer ${sessionStorage.getItem('jwtToken')}`;
  return req.post(`${USER_REQUESTS}`, formData);
}

/**
 * Get organization data with uid
 * @returns 
 */
export const GetRequestData = () => {
  Axios.defaults.headers.common.Authorization = `Bearer ${sessionStorage.getItem('jwtToken')}`;
  return Axios.get(`${USER_REQUESTS}`);
}

/**
 * Edit patient Request
 * @param formData 
 * @returns 
 */
export const EditRequest = (request_id: number, formData: any) => {
  Axios.defaults.headers.common.Authorization = `Bearer ${sessionStorage.getItem('jwtToken')}`;
  return Axios.put(`${USER_REQUESTS}/${request_id}`, formData);
}